import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetTransactionSingleReport  {
    _originalTypeClassName = "zERP.BO.AssetTransactionSingleReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetTransactionSingleReport.translate = translateService;
}
this.Date = null;
this.GroupBy = null;
this.TransactionType = null;
this.DepreciationValue = null;
this.AcquisitionValue = null;
this.AdjustmentValue = null;
this.ImprovementValue = null;
this.TotalValue = null;
this.NonDepreciatedValue = null;
this.AssetTransactionSingleReportKey = null;
this._key = this.AssetTransactionSingleReportKey = 0; 
}

static translate: TranslateService;
_key: any;
Date:any;
GroupBy:any;
TransactionType:any;
DepreciationValue:any;
AcquisitionValue:any;
AdjustmentValue:any;
ImprovementValue:any;
TotalValue:any;
NonDepreciatedValue:any;
private _AssetTransactionSingleReportKey:any;
get AssetTransactionSingleReportKey(): any {
    return this._AssetTransactionSingleReportKey;
  }
set AssetTransactionSingleReportKey(value: any) {
    this._AssetTransactionSingleReportKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AssetTransactionSingleReportKey == null || $this.AssetTransactionSingleReportKey == 0;
            }


}